import React, { useState } from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import Footer from '../../component/layout/Footer';
import emailjs from "@emailjs/browser";

const ContactUs = () => {

    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(
                "service_85vncqh",
                "template_sh7wgvk",
                "#myForm",
                "dphUMCkFYP0BZruxu"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };

    return (
        <>
            <div className="page-header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="page-header-box">
                                <h1 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                    <div className="split-line" style={{ display: 'block', textAlign: 'center', position: 'relative' }}>
                                        Contact us
                                    </div>
                                </h1>
                                <nav className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Contact us</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-contact-us">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Contact Info List Start */}
                            <div className="contact-info-list">
                                {/* Contact Info Item Start */}
                                <div className="contact-info-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-phone-white.svg" alt />
                                    </div>
                                    <div className="contact-info-content">
                                        <h3>Contact Us</h3>
                                        <p><a href="tel:+91 6262556132">+91 6262556132</a></p>
                                    </div>
                                </div>
                                {/* Contact Info Item End */}
                                {/* Contact Info Item Start */}
                                <div className="contact-info-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-mail-white.svg" alt />
                                    </div>
                                    <div className="contact-info-content">
                                        <h3>E - Mail</h3>
                                        <p><a href="mailto:cndsuperfood@gmail.com">cndsuperfood@gmail.com</a></p>
                                    </div>
                                </div>
                                {/* Contact Info Item End */}
                                {/* Contact Info Item Start */}
                                <div className="contact-info-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-location-white.svg" alt />
                                    </div>
                                    <div className="contact-info-content">
                                        <h3>Address</h3>
                                        <p><a style={{ color: "" }} target="_blank" href='https://maps.app.goo.gl/j5sbmjH9CUyLgK996'>Dhairya Enterprises, 01, Ganesh Nagar Tehsil Raghuraj Nagar, Near Chandra Say, Satna (M.p.)</a></p>
                                    </div>
                                </div>
                                {/* Contact Info Item End */}
                                {/* Contact Info Item Start */}
                                <div className="contact-info-item wow fadeInUp" data-wow-delay="0.6s" style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-clock-white.svg" alt />
                                    </div>
                                    <div className="contact-info-content">
                                        <h3>Working hours</h3>
                                        <p>Mon-Sat : 10am to 07pm</p>
                                        <p>Sunday: Closed</p>
                                    </div>
                                </div>
                                {/* Contact Info Item End */}
                            </div>
                            {/* Contact Info List Start */}
                        </div>
                        <div className="col-lg-12">
                            {/* Contact Us Form Start */}
                            <div className="conatct-us-form">
                                {/* Google Map Iframe Start */}
                                <div className="google-map-iframe">
                                    <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1600&height=400&hl=en&q=CND, 01, Ganesh Nagar, Tehsil Raghuraj Nagar, Dhairya Enterprises, near Chandra Say, Satna, Madhya Pradesh 485005, India&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google maps embed</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>


                                </div>
                                {/* Google Map Iframe End */}
                                {/* Contact Form Start */}
                                <div className="contact-form dark-section">
                                    {/* Section Title Start */}
                                    <div className="section-title">
                                        <h2 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}><div className="split-line" style={{ display: 'block', textAlign: 'start', position: 'relative' }}><div style={{ position: 'relative', display: 'inline-block' }}><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>S</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>e</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>n</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>d</div></div> <div style={{ position: 'relative', display: 'inline-block' }}><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>u</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>s</div></div> <div style={{ position: 'relative', display: 'inline-block' }}><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>m</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>e</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>s</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>s</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>a</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>g</div><div style={{ position: 'relative', display: 'inline-block', transform: 'translate(0px, 0px)', opacity: 1 }}>e</div></div></div></h2>
                                    </div>
                                    {/* Section Title End */}
                                    {/* Contact Form Start */}
                                    <form id="contactForm" action="#" method="POST" data-toggle="validator" className="wow fadeInUp" data-wow-delay="0.2s" noValidate="true" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                        <div className="row">
                                            <div className="form-group col-md-6 mb-4">
                                                <input type="text" name="fname" className="form-control" id="fname" placeholder="First Name" required />
                                                <div className="help-block with-errors" />
                                            </div>
                                            <div className="form-group col-md-6 mb-4">
                                                <input type="text" name="lname" className="form-control" id="lname" placeholder="Last Name" required />
                                                <div className="help-block with-errors" />
                                            </div>
                                            <div className="form-group col-md-6 mb-4">
                                                <input type="email" name="email" className="form-control" id="email" placeholder="Email" required />
                                                <div className="help-block with-errors" />
                                            </div>
                                            <div className="form-group col-md-6 mb-4">
                                                <input type="text" name="phone" className="form-control" id="phone" placeholder="Phone" required />
                                                <div className="help-block with-errors" />
                                            </div>
                                            <div className="form-group col-md-12 mb-5">
                                                <textarea name="message" className="form-control" id="message" rows={4} placeholder="Message..." defaultValue={""} />
                                                <div className="help-block with-errors" />
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="contact-form-btn">
                                                    <Link to="/">
                                                        <button type="submit" className="btn-default btn-highlighted disabled"><span>Submit Message</span></button>
                                                    </Link>
                                                    <div id="msgSubmit" className="h3 hidden" />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    {/* Contact Form End */}
                                </div>
                                {/* Contact Form End */}
                            </div>
                            {/* Contact Us Form End */}
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default ContactUs